export const routes = {
    dashboard: {
        path: "dashboard",
    },
    widgets: {
        path: "widgets",
    },
    templates: {
        path: "templates",
    },
    settings: {
        path: "settings",
    },
    onboarding: {
        path: "onboarding",
    },
    upgrade: {
        path: "upgrade",
    },
    headerFooterBuilder: { 
        path: "elementor-hf" 
    }
}